import React, { useState, useEffect } from 'react';
import { FaFilter, FaCopy, FaChevronDown, FaChevronUp, FaQuestionCircle, FaQuestion } from 'react-icons/fa';
import './AlertsDetailModal.css';
import '../pages/QuestionsPage.css'
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

function AlertsDetailModal({ alert: alertData, onClose, onApplyFilter, onChangeState, showButtons = true, allAlerts = [] }) {
  const [hoveredField, setHoveredField] = useState(null);
  const [isIpVisible, setIsIpVisible] = useState(false);
  const [isPeerIpVisible, setIsPeerIpVisible] = useState(false);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [relatedAlerts, setRelatedAlerts] = useState([]);
  const [relatedFilterType, setRelatedFilterType] = useState("both"); // "org", "peer", ou "both"
  const [isQuestionModalOpen, setIsQuestionModalOpen] = useState(false);
  const [questionText, setQuestionText] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [alertText, setAlertText] = useState('');

  // Adicione esta função junto com as outras funções do componente:
  const { API_BASE_URL } = useAuth();

  // Não precisamos mais deslocar o modal principal quando o de detalhes está aberto
  const [mainModalPosition, setMainModalPosition] = useState('center');

  const navigate = useNavigate();

  let alertIdParam = alertData.description ? alertData.description.split(":")[0] : "";
  if (alertIdParam === "Anomaly") {
      alertIdParam = alertData._id;
  }

  const get_text = async () => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_BASE_URL}alert_info/${alertIdParam}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json', Authorization: token,
      }
    });
    const data = await response.json()
    setAlertText(data.message)

  };
  useEffect(() => {
    get_text();
    if (allAlerts.length > 0) {
      let filteredAlerts = [];

      switch (relatedFilterType) {
        case "org":
          // Apenas com mesmo organization_ip
          filteredAlerts = allAlerts.filter(alert =>
            alert._id !== alertData._id &&
            alert.organization_ip === alertData.organization_ip
          );
          break;
        case "peer":
          // Apenas com mesmo peer_ip
          filteredAlerts = allAlerts.filter(alert =>
            alert._id !== alertData._id &&
            alert.peer_ip && alertData.peer_ip &&
            alert.peer_ip === alertData.peer_ip
          );
          break;
        case "both":
          // Com ambos organization_ip e peer_ip iguais
          filteredAlerts = allAlerts.filter(alert =>
            alert._id !== alertData._id &&
            alert.organization_ip === alertData.organization_ip &&
            alert.peer_ip && alertData.peer_ip &&
            alert.peer_ip === alertData.peer_ip
          );
          break;
      }

      setRelatedAlerts(filteredAlerts);
    }
  }, [alertData, allAlerts, relatedFilterType]);

  const handleCopyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  const handleTogglePeerIp = () => {
    setIsPeerIpVisible((prev) => !prev);
  };

  const handleToggleDetails = () => {
    setIsDetailsModalOpen((prev) => !prev);
  };

  const handleToggleIp = () => {
    setIsIpVisible((prev) => !prev);
  };

  const handleFilter = (field, value) => {
    if (onApplyFilter) {
      onApplyFilter(field, value);
    }
    onClose();
  };

  const handleChangeRelatedFilter = (filterType) => {
    setRelatedFilterType(filterType);
  };

  const handleChangeState = (newState) => {
    if (onChangeState) {
      onChangeState({ id: alertData._id, index: alertData._index }, newState);
    }
    onClose();
  };

  const openQuestionModal = () => {
    setIsQuestionModalOpen(true);
    setQuestionText('');
    setSubmitError('');
    setSubmitSuccess(false);
  };

  const closeQuestionModal = () => {
    setIsQuestionModalOpen(false);
  };

  const handleQuestionTextChange = (e) => {
    setQuestionText(e.target.value);
  };

  const submitQuestion = async () => {
    if (!questionText.trim()) {
      setSubmitError('Please enter a question.');
      return;
    }

    setIsSubmitting(true);
    setSubmitError('');

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}questions`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json', Authorization: token,
        },
        body: JSON.stringify({
          question: questionText,
          alert_id: alertData._id,
          id: alertData.description,
          category: 'alert'
        }),
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      setSubmitSuccess(true);
      setTimeout(() => {
        closeQuestionModal();
      }, 1500);
    } catch (error) {
      setSubmitError(`Failed to submit question: ${error.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  function formatDate(timestamp) {
    const date = new Date(timestamp);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }

  const NestedDetailRenderer = ({ details, depth = 0 }) => {
    const [expanded, setExpanded] = React.useState({});

    const toggleExpand = (key) => {
      setExpanded(prev => ({
        ...prev,
        [key]: !prev[key]
      }));
    };

    if (!details || typeof details !== 'object') {
      return <div className="text-gray-500">No details available</div>;
    }

    return Object.entries(details).map(([key, value]) => {
      const isObject = value !== null && typeof value === 'object';
      const indent = depth * 16;

      return (
        <div key={key}>
          <div
            className="flex"
            style={{ marginLeft: `${indent}px` }}
          >
            {isObject && (
              <div
                onClick={() => toggleExpand(key)}
                style={{ cursor: 'pointer' }}
              >
                {expanded[key] ? <FaChevronUp /> : <FaChevronDown />}
              </div>
            )}
            {!isObject && <span className="w-4"></span>}

            <div className="flex-1">
              <strong>{key}</strong>: {isObject
                ? `{${Object.keys(value).length} items}`
                : String(value)
              }
            </div>
          </div>

          {isObject && expanded[key] && (
            <div className="pl-4">
              <NestedDetailRenderer details={value} depth={depth + 1} />
            </div>
          )}
        </div>
      );
    });
  };

  const renderDetailsAsLines = (details) => {
    return (
      <div className="border border-gray-200 rounded p-4 bg-gray-50">
        <NestedDetailRenderer details={details} />
      </div>
    );
  };

  return (
    <div
      className="modals-container"
      style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
    >
      {/* Modal Principal - não muda de posição mais */}
      <div
        className={`modal show main-modal ${mainModalPosition}`}
        style={{ display: 'block' }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Alert Details {`(${formatDate(alertData.timestamp)})`}</h5>
              <button type="button" className="btn-close" onClick={onClose} />
            </div>
            <div className="modal-body">
              {/* Organization Host */}
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div
                  className="detail-field"
                  onClick={handleToggleIp}
                  style={{ cursor: 'pointer', marginRight: '8px' }}
                >
                  {isIpVisible ? <FaChevronUp /> : <FaChevronDown />}
                </div>

                <div
                  className="detail-field"
                  onMouseEnter={() => setHoveredField('organizationHost')}
                  onMouseLeave={() => setHoveredField(null)}
                >
                  <b>Organization Host/IP:</b> {`${alertData.organization_hostname}`}

                  {hoveredField === 'organizationHost' && (
                    <span className="hover-icons">
                      <FaFilter
                        className="hover-icon"
                        title="Filter by Organization Host"
                        onClick={() => handleFilter('organization_hostname', alertData.organization_hostname)}
                      />
                      <FaCopy
                        className="hover-icon"
                        title="Copy Organization Host"
                        onClick={() => handleCopyToClipboard(alertData.organization_hostname)}
                      />
                      <FaQuestionCircle
                        className="hover-icon"
                        title="See questions related with this host"
                        onClick={() => { navigate(`/questions?id=${alertData.organization_hostname}`); }}
                      />
                    </span>
                  )}
                </div>
              </div>

              {isIpVisible && (
                <div
                  className="detail-field"
                  onMouseEnter={() => setHoveredField('organizationIp')}
                  onMouseLeave={() => setHoveredField(null)}
                  style={{ marginLeft: 30 }}
                >
                  <b>Organization IP:</b> {alertData.organization_ip}
                  {hoveredField === 'organizationIp' && (
                    <span className="hover-icons">
                      <FaFilter
                        className="hover-icon"
                        title="Filter by Organization IP"
                        onClick={() => handleFilter('organization_ip', alertData.organization_ip)}
                      />
                      <FaCopy
                        className="hover-icon"
                        title="Copy Organization IP"
                        onClick={() => handleCopyToClipboard(alertData.organization_ip)}
                      />
                    </span>
                  )}
                </div>
              )}

              <p><b>Organization Port:</b> {alertData.organization_port}</p>

              {(alertData.peer_hostname || alertData.peer_ip) && (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {alertData.peer_hostname && (
                    <div
                      className="detail-field"
                      onClick={handleTogglePeerIp}
                      style={{ cursor: 'pointer', marginRight: '8px' }}
                    >
                      {isPeerIpVisible ? <FaChevronUp /> : <FaChevronDown />}
                    </div>
                  )}

                  <div
                    className="detail-field"
                    onMouseEnter={() => setHoveredField('peerHost')}
                    onMouseLeave={() => setHoveredField(null)}
                  >
                    <b>Peer Host/IP:</b> {alertData.peer_hostname || alertData.peer_ip}
                    {hoveredField === 'peerHost' && (
                      <span className="hover-icons">
                        <FaFilter
                          className="hover-icon"
                          title="Filter by Peer Host"
                          onClick={() => handleFilter('peer_hostname', alertData.peer_hostname)}
                        />
                        <FaCopy
                          className="hover-icon"
                          title="Copy Peer Host"
                          onClick={() => handleCopyToClipboard(alertData.peer_hostname)}
                        />
                      </span>
                    )}
                  </div>
                </div>
              )}

              {isPeerIpVisible && (
                <div
                  className="detail-field"
                  onMouseEnter={() => setHoveredField('peerIp')}
                  onMouseLeave={() => setHoveredField(null)}
                  style={{ marginLeft: 30 }}
                >
                  <b>Peer IP:</b> {alertData.peer_ip}
                  {hoveredField === 'peerIp' && (
                    <span className="hover-icons">
                      <FaFilter
                        className="hover-icon"
                        title="Filter by Peer IP"
                        onClick={() => handleFilter('peer_ip', alertData.peer_ip)}
                      />
                      <FaCopy
                        className="hover-icon"
                        title="Copy Peer IP"
                        onClick={() => handleCopyToClipboard(alertData.peer_ip)}
                      />
                    </span>
                  )}
                </div>
              )}

              <p><b>Peer Port:</b> {alertData.peer_port}</p>
              {alertData.peer_geo && <p><b>Peer GeoIP:</b> {alertData.peer_geo}</p>}

              {/* Alert Description */}
              <div
                className="detail-field"
                onMouseEnter={() => setHoveredField('alertDescription')}
                onMouseLeave={() => setHoveredField(null)}
              >
                <b>Alert Description:</b> {alertData.description}
                {hoveredField === 'alertDescription' && (
                  <span className="hover-icons">
                    <FaFilter
                      className="hover-icon"
                      title="Filter by Alert Description"
                      onClick={() => handleFilter('description', alertData.description)}
                    />
                    <FaCopy
                      className="hover-icon"
                      title="Copy Alert Description"
                      onClick={() => handleCopyToClipboard(alertData.description)}
                    />
                    <FaQuestionCircle
                      className="hover-icon"
                      title="See questions related with this alert"
                      onClick={() => { navigate(`/questions?id=${alertIdParam}`); }}
                    />
                  </span>
                )}
              </div>

              <div className="detail-field">
                <b>Direction:</b> <p>{alertData.direction}</p>
              </div>

              {alertData.false_alarm_reason && (
                <div className="detail-field">
                  <b>Reason for False Alarm:</b> <p>{alertData.false_alarm_reason}</p>
                </div>
              )}
            </div>

            <div style={{ display: 'flex', alignItems: 'center', padding: '0 15px' }}>
              <div
                className="detail-field"
                onClick={handleToggleDetails}
                style={{ cursor: 'pointer', marginRight: '8px' }}
              >
                {isDetailsModalOpen ? <FaChevronUp /> : <FaChevronDown />}
              </div>
              <b>More Details</b>
            </div>

            {/* New Question Button */}
            <div style={{ padding: '10px 15px' }}>
              <button
                className="btn btn-info"
                onClick={openQuestionModal}
                style={{ display: 'flex', alignItems: 'center', gap: '5px' }}
              >
                <FaQuestion /> Ask a Question about this Alert
              </button>
            </div>

            {showButtons && (
              <div className="modal-footer">
                <button
                  className="btn btn-warning"
                  title="New identical alerts will not be shown, but the alert is not considered closed until the state is updated."
                  onClick={() => handleChangeState('INV')}
                >
                  Mark as Investigating
                </button>
                <button
                  className="btn btn-success"
                  title="Identical alarms will be shown in the future, this instance is considered closed."
                  onClick={() => handleChangeState('CLSD')}
                >
                  Close as Positive
                </button>
                <button
                  title="Alarm will be closed and identical alarms will be discarded in the future."
                  className="btn btn-danger"
                  onClick={() => handleChangeState('FA')}
                >
                  Close as False Alarm
                </button>
                <button className="btn btn-secondary" onClick={onClose}>
                  Leave Unchanged
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Question Modal */}
      {isQuestionModalOpen && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100vw',
            height: '100vh',
            zIndex: '1060', // Higher than other modals
            backgroundColor: 'rgba(0,0,0,0.7)'
          }}
        >
          <div
            style={{
              width: '95%',
              maxWidth: '600px',
              backgroundColor: 'white',
              borderRadius: '8px',
              boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
            }}
          >
            {isSubmitting && (
              <div className="loading-spinner-overlay">
                <div className="loading-spinner"></div>
              </div>
            )}
            <div className="modal-header" style={{ padding: '1rem', borderBottom: '1px solid #dee2e6' }}>
              <h5 className="modal-title" style={{ margin: 0 }}>Ask a Question about this Alert</h5>
              <button
                type="button"
                className="btn-close"
                onClick={closeQuestionModal}
              />
            </div>
            <div className="modal-body" style={{ padding: '1rem' }}>
              <p>Your question will be associated with alert ID: <strong>{alertData._id}</strong></p>

              <div className="mb-3">
                <label htmlFor="questionTextarea" className="form-label">Your Question:</label>
                <textarea
                  id="questionTextarea"
                  className="form-control"
                  rows="5"
                  value={questionText}
                  onChange={handleQuestionTextChange}
                  placeholder="Enter your question here..."
                  style={{ resize: 'vertical' }}
                ></textarea>
              </div>

              {submitError && (
                <div className="alert alert-danger" role="alert">
                  {submitError}
                </div>
              )}

              {submitSuccess && (
                <div className="alert alert-success" role="alert">
                  Question submitted successfully!
                </div>
              )}
            </div>
            <div className="modal-footer" style={{ padding: '1rem', borderTop: '1px solid #dee2e6' }}>
              <button
                className="btn btn-secondary"
                onClick={closeQuestionModal}
                disabled={isSubmitting}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={submitQuestion}
                disabled={isSubmitting || !questionText.trim()}
              >
                {isSubmitting ? 'Submitting...' : 'Submit Question'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Detalhes - agora centralizado e em tela quase cheia */}

      {alertText && !isDetailsModalOpen && (
        <div
          style={{
            position: 'fixed',
            top: '50%',
            right: '20px',
            transform: 'translateY(-50%)',
            width: '33%',
            maxHeight: '80vh',
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
            zIndex: '1055',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <div className="modal-header" style={{ padding: '1rem', borderBottom: '1px solid #dee2e6' }}>
            <h5 className="modal-title" style={{ margin: 0 }}>Helper</h5>
          </div>
          <div className="modal-body" style={{
            flex: '1 1 auto',
            padding: '1rem',
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
            fontFamily: 'monospace',
            fontSize: '14px',
            lineHeight: '1.4'
          }}>
            {alertText}
          </div>
        </div>
      )}
      {isDetailsModalOpen && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100vw',
            height: '100vh',
            zIndex: '1050',
            backgroundColor: 'rgba(0,0,0,0.7)',
            padding: '20px'
          }}
        >
          <div
            style={{
              width: '95%',
              maxWidth: '1600px',
              height: '90vh',
              backgroundColor: 'white',
              borderRadius: '8px',
              boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <div className="modal-header" style={{ padding: '1rem', borderBottom: '1px solid #dee2e6' }}>
              <h5 className="modal-title" style={{ margin: 0 }}>Additional Details</h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleToggleDetails}
                style={{ background: 'transparent', border: 'none', fontSize: '1.5rem', cursor: 'pointer' }}
              />
            </div>
            <div className="modal-body" style={{
              flex: '1 1 auto',
              padding: '1rem',
              overflow: 'auto'
            }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div
                  className="detail-field"
                  onClick={handleToggleIp}
                  style={{ cursor: 'pointer', marginRight: '8px' }}
                >
                  {isIpVisible ? <FaChevronUp /> : <FaChevronDown />}
                </div>

                <div
                  className="detail-field"
                  onMouseEnter={() => setHoveredField('organizationHost')}
                  onMouseLeave={() => setHoveredField(null)}
                >
                  <b>Organization Host/IP:</b> {`${alertData.organization_hostname}`}

                  {hoveredField === 'organizationHost' && (
                    <span className="hover-icons">
                      <FaFilter
                        className="hover-icon"
                        title="Filter by Organization Host"
                        onClick={() => handleFilter('organization_hostname', alertData.organization_hostname)}
                      />
                      <FaCopy
                        className="hover-icon"
                        title="Copy Organization Host"
                        onClick={() => handleCopyToClipboard(alertData.organization_hostname)}
                      />
                    </span>
                  )}
                </div>
              </div>

              {isIpVisible && (
                <div
                  className="detail-field"
                  onMouseEnter={() => setHoveredField('organizationIp')}
                  onMouseLeave={() => setHoveredField(null)}
                  style={{ marginLeft: 30 }}
                >
                  <b>Organization IP:</b> {alertData.organization_ip}
                  {hoveredField === 'organizationIp' && (
                    <span className="hover-icons">
                      <FaFilter
                        className="hover-icon"
                        title="Filter by Organization IP"
                        onClick={() => handleFilter('organization_ip', alertData.organization_ip)}
                      />
                      <FaCopy
                        className="hover-icon"
                        title="Copy Organization IP"
                        onClick={() => handleCopyToClipboard(alertData.organization_ip)}
                      />
                    </span>
                  )}
                </div>
              )}

              <p><b>Organization Port:</b> {alertData.organization_port}</p>

              {(alertData.peer_hostname || alertData.peer_ip) && (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {alertData.peer_hostname && (
                    <div
                      className="detail-field"
                      onClick={handleTogglePeerIp}
                      style={{ cursor: 'pointer', marginRight: '8px' }}
                    >
                      {isPeerIpVisible ? <FaChevronUp /> : <FaChevronDown />}
                    </div>
                  )}

                  <div
                    className="detail-field"
                    onMouseEnter={() => setHoveredField('peerHost')}
                    onMouseLeave={() => setHoveredField(null)}
                  >
                    <b>Peer Host/IP:</b> {alertData.peer_hostname || alertData.peer_ip}
                    {hoveredField === 'peerHost' && (
                      <span className="hover-icons">
                        <FaFilter
                          className="hover-icon"
                          title="Filter by Peer Host"
                          onClick={() => handleFilter('peer_hostname', alertData.peer_hostname)}
                        />
                        <FaCopy
                          className="hover-icon"
                          title="Copy Peer Host"
                          onClick={() => handleCopyToClipboard(alertData.peer_hostname || alertData.peer_ip)}
                        />
                      </span>
                    )}
                  </div>
                </div>
              )}

              {isPeerIpVisible && (
                <div
                  className="detail-field"
                  onMouseEnter={() => setHoveredField('peerIp')}
                  onMouseLeave={() => setHoveredField(null)}
                  style={{ marginLeft: 30 }}
                >
                  <b>Peer IP:</b> {alertData.peer_ip}
                  {hoveredField === 'peerIp' && (
                    <span className="hover-icons">
                      <FaFilter
                        className="hover-icon"
                        title="Filter by Peer IP"
                        onClick={() => handleFilter('peer_ip', alertData.peer_ip)}
                      />
                      <FaCopy
                        className="hover-icon"
                        title="Copy Peer IP"
                        onClick={() => handleCopyToClipboard(alertData.peer_ip)}
                      />
                    </span>
                  )}
                </div>
              )}

              <p><b>Peer Port:</b> {alertData.peer_port}</p>
              {alertData.peer_geo && <p><b>Peer GeoIP:</b> {alertData.peer_geo}</p>}

              {/* Alert Description */}
              <div
                className="detail-field"
                onMouseEnter={() => setHoveredField('alertDescription')}
                onMouseLeave={() => setHoveredField(null)}
              >
                <b>Alert Description:</b> {alertData.description}
                {hoveredField === 'alertDescription' && (
                  <span className="hover-icons">
                    <FaFilter
                      className="hover-icon"
                      title="Filter by Alert Description"
                      onClick={() => handleFilter('description', alertData.description)}
                    />
                    <FaCopy
                      className="hover-icon"
                      title="Copy Alert Description"
                      onClick={() => handleCopyToClipboard(alertData.description)}
                    />
                  </span>
                )}
              </div>

              <div className="detail-field">
                <b>Direction:</b> <p>{alertData.direction}</p>
              </div>

              {alertData.false_alarm_reason && (
                <div className="detail-field">
                  <b>Reason for False Alarm:</b> <p>{alertData.false_alarm_reason}</p>
                </div>
              )}

              {alertData.details && (
                <div className="detail-field">
                  <b>Alert Details:</b>
                  {renderDetailsAsLines(alertData.details)}
                </div>
              )}
              {alertData.alertText && (
                <div className="detail-field">
                  <b>Alert Text:</b>
                  <p>{alertData.alertText || 'No additional text provided.'}</p>
                </div>
              )}
              {!alertData.details && !alertData.alertText && (
                <div className="text-gray-500">No additional details available</div>
              )}
            </div>

            <div className="filter-buttons-group" style={{ display: 'flex', gap: '10px' }}>
              <h4 style={{ borderBottom: '1px solid #dee2e6', paddingBottom: '10px' }}>
                Related Alerts ({relatedAlerts.length})
              </h4>
              <button
                className={`btn ${relatedFilterType === 'both' ? 'btn-primary' : 'btn-outline-primary'}`}
                onClick={() => handleChangeRelatedFilter('both')}
                title="Show alerts with both same organization IP and peer IP"
              >
                Same Org & Peer IP
              </button>
              <button
                className={`btn ${relatedFilterType === 'org' ? 'btn-primary' : 'btn-outline-primary'}`}
                onClick={() => handleChangeRelatedFilter('org')}
                title="Show alerts with same organization IP only"
              >
                Same Org IP
              </button>
              <button
                className={`btn ${relatedFilterType === 'peer' ? 'btn-primary' : 'btn-outline-primary'}`}
                onClick={() => handleChangeRelatedFilter('peer')}
                title="Show alerts with same peer IP only"
              >
                Same Peer IP
              </button>
            </div>
            {relatedAlerts.length > 0 && (
              <div className="related-alerts-section" style={{ marginBottom: '20px' }}>
                <div className="related-alerts-list" style={{ maxHeight: '300px', overflow: 'auto' }}>
                  <table className="table table-striped table-hover" style={{ width: '100%' }}>
                    <thead>
                      <tr>
                        <th>Timestamp</th>
                        <th>Description</th>
                        <th>Direction</th>
                        <th>Organization</th>
                        <th>Peer</th>
                        <th>State</th>
                      </tr>
                    </thead>
                    <tbody>
                      {relatedAlerts.map((alert) => (
                        <tr key={alert._id} style={{ cursor: 'pointer' }}>
                          <td>{formatDate(alert.timestamp)}</td>
                          <td>{alert.description}</td>
                          <td>{alert.direction}</td>
                          <td>{alert.organization_hostname}</td>
                          <td>{alert.peer_hostname || alert.peer_ip}</td>
                          <td>
                            <span className={`badge bg-${alert.state === 'NEW' ? 'primary' :
                              alert.state === 'INV' ? 'warning' :
                                alert.state === 'CLSD' ? 'success' :
                                  alert.state === 'FA' ? 'danger' : 'secondary'
                              }`}>
                              {alert.state || 'NEW'}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            <div className="modal-footer" style={{
              padding: '1rem',
              borderTop: '1px solid #dee2e6',
              display: 'flex',
              justifyContent: 'flex-end'
            }}>
              <button
                className="btn btn-secondary"
                onClick={handleToggleDetails}
                style={{
                  padding: '0.375rem 0.75rem',
                  backgroundColor: '#6c757d',
                  color: 'white',
                  border: 'none',
                  borderRadius: '0.25rem',
                  cursor: 'pointer'
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AlertsDetailModal;
